import { render } from "./LeaveFormControl.vue?vue&type=template&id=685582c8&scoped=true"
import script from "./LeaveFormControl.vue?vue&type=script&lang=js"
export * from "./LeaveFormControl.vue?vue&type=script&lang=js"

import "./LeaveFormControl.vue?vue&type=style&index=0&id=685582c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685582c8"]])

export default __exports__